import React from 'react';
import { Linkedin, Twitter, Github, MapPin, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-border-medium py-12 px-6 lg:px-[7.69%]">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center mb-5" style={{ letterSpacing: '1px' }}>
            <span className="text-brand-primary font-bold text-base leading-none">/</span>
            <span className="text-text-primary font-bold text-base leading-none tracking-wider">FALCON42</span>
          </div>
          <p className="body-medium max-w-md mb-6">
            Building the autonomous enterprise of tomorrow, today.
            Specializing in agentic workflows, predictive modeling, and secure LLM infrastructure.
          </p>

          <div className="flex flex-col gap-2 text-text-muted border-l-2 border-brand-primary/40 pl-4" style={{ fontSize: '11px' }}>
            <div className="flex items-start gap-2">
              <MapPin className="w-3.5 h-3.5 mt-0.5 text-brand-primary shrink-0" />
              <div>
                <p>245, 4 Peddlers Row</p>
                <p>Newark, DE 19702</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-1">
              <FileText className="w-3.5 h-3.5 text-brand-primary shrink-0" />
              <p>EIN: 37-2144924</p>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-text-primary uppercase mb-4" style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px' }}>Sitemap</h4>
          <ul className="flex flex-col gap-3 text-text-secondary uppercase" style={{ fontSize: '10px', letterSpacing: '0.8px' }}>
            <li><a href="/#services" className="hover:text-brand-primary transition-colors">Services</a></li>
            <li><a href="/#case-studies" className="hover:text-brand-primary transition-colors">Case Studies</a></li>
            <li><a href="/#testimonials" className="hover:text-brand-primary transition-colors">Testimonials</a></li>
            <li><a href="/#blog" className="hover:text-brand-primary transition-colors">Insights</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-text-primary uppercase mb-4" style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px' }}>Connect</h4>
          <div className="flex gap-3">
            <a href="https://www.linkedin.com/company/falcon42-ai" target="_blank" rel="noopener noreferrer" className="p-2 border border-border-medium text-text-secondary hover:bg-brand-primary hover:text-black hover:border-brand-primary transition-all">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 border border-border-medium text-text-secondary hover:bg-brand-primary hover:text-black hover:border-brand-primary transition-all">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 border border-border-medium text-text-secondary hover:bg-brand-primary hover:text-black hover:border-brand-primary transition-all">
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto pt-6 border-t border-border-subtle flex flex-col md:flex-row justify-between text-text-muted uppercase gap-3" style={{ fontSize: '10px', letterSpacing: '0.8px' }}>
        <p>© 2025 Falcon42 Automation. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-brand-primary transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-brand-primary transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
